import React, { Component } from 'react'
import '../styles/survey.css'
import apigClientFactory from 'aws-api-gateway-client'
import aws from '../aws-config'

export default class Survey extends Component {
  state = {
    index: 0,
    data: [],
    loading: true,
    retry: false,
    showSurvey: false,
    showCorrect: false,
    showThanks: false,
    showError: false
  }

  componentDidMount() {
    this.getSurveyData()
  }

  onLoad = json => {
    this.setState({
      index: 0,
      data: json,
      loading: false,
      retry: false,
      showSurvey: true,
      showCorrect: false,
      showThanks: false
    })
  }

  showError = () => {
    this.setState({
      loading: false,
      retry: false,
      showSurvey: false,
      showCorrect: false,
      showThanks: false,
      showError: true
    })
  }

  showCorrect = () => {
    this.setState({
      loading: false,
      retry: false,
      showSurvey: false,
      showCorrect: true,
      showThanks: false
    })
  }

  showThanks = () => {
    this.setState({
      loading: false,
      retry: false,
      showSurvey: false,
      showCorrect: false,
      showThanks: true
    })
  }

  getSurveyData = () => {
    switch(this.props.module) {
      case "informative":
        this.onLoad(
          [
            {
              "question_1": "What would be an example of being knowledgeable?",
              "answer_1": [
                "Providing excellent one-stop service",
                "Directing the guest to the appropriate service",
                "When possible, showing them the way",
                "Trying to find answers for the guest when you don’t know the answer",
                "All of the above"
              ],
              "correct_answer": "All of the above"
            },
            {
              "question_2": "What is the most important step in responding to a guest’s needs?",
              "answer_2": [
                "Thinking what’s right and not who is right",
                "Abruptly directing them to the information booth",
                "Listening first to the guest",
                "Cutting the guest off in mid-sentence and pointing in the general direction"
              ],
              "correct_answer": "Listening first to the guest"
            }
          ]
        );
        break;
      case "courteous":
        this.onLoad(
          [
            {
              "question_1": "What behaviors should I demonstrate to be courteous?",
              "answer_1": [
                "Smiling, being friendly, energetic, and sincere",
                "Being respectful and culturally sensitive",
                "Make good eye contact and be attentive",
                "Be patient with my words, intent and feelings",
                "All of the above"

          ],
              "correct_answer": "All of the above"
            },
            {
              "question_2": "How should you respond to a question that you hear 100 times a day?",
              "answer_2": [
                "Rolling your eyes and sighing",
                "Abruptly stopping the guest from talking and quickly giving them the answer",
                "Being patient with my words, intent and feelings"

          ],
              "correct_answer": "Being patient with my words, intent and feelings"
            }
          ]
        );
        break;
      case "introduction":
        this.onLoad(
          [
            {
              "question_1": "The airport service delivery chain is one big chain comprised of the entire airport journey from curbside to gateside and back. The airport service delivery chain should provide a ______________ level of service on a daily basis.",
              "answer_1": [
                "Confusing",
                "Unhappy",
                "Consistent",
                "Unexpected"
              ],
              "correct_answer": "Consistent"
            },
            {
              "question_2": "Who is responsible for clear communication and collaboration to maintain a positive guest experience?",
              "answer_2": [
                "Deborah Flint, Chief Executive Officer",
                "Everyone across the service delivery chain",
                "My boss",
                "Not me"
              ],
              "correct_answer": "Everyone across the service delivery chain"
            }
          ]
        );
        break;
      case "approachable":
        this.onLoad(
          [
            {
              "question_1": "What behaviors should I demonstrate to be approachable?",
              "answer_1": [
                "Being accessible and visible",
                "Demonstrating positive body language",
                "Being professional in appearance and action",
                "Demonstrating a “can do” attitude",
                "All of the above"
      ],
              "correct_answer": "All of the above"
            },{ 
             "question_2": "What should you do if you see that a guest looks lost?",
             "answer_2": [
               "Approach and assist",
               "Wait for them to approach you",
               "Approach only if they are famous",
               "Pretend that you don’t notice and return to your task",
             ],
             "correct_answer": "Approach and assist"
            }
          ]
        );
        break;

      case "responsive":
        this.onLoad([
          {
            "question_1": "What behaviors should I demonstrate to be responsive?",
            "answer_1": [
              "Empathizing with a sense of urgency",
              "Actively listening",
              "Anticipating guests’ needs",
              "Being thoughtful and provide accurate and meaningful responses",
              "Being aware of safety and security risks",
              "All of the above"

      ],
            "correct_answer": "All of the above"
          },
          {
            "question_2": "How can you demonstrate awareness of safety and security risks?",
            "answer_2": [
              "Demonstrating airport pride by reporting any spills in the area",
              "Reporting areas in need of repair",
              "Being prepared for all situations",
              "See something, say something",
              "All of the above",
          ],
            "correct_answer": "All of the above"
          }
        ]);
        break;

      case "efficient_effective":
        this.onLoad([
          {
            "question_1": "What behaviors should I demonstrate to be efficient and effective?",
            "answer_1": [
              "Clearly communicating",
              "Being resourceful",
              "Helping ensure consistent processes and communication",
              "Taking ownership of situations and handle with confidence",
              "All of the above",
          ],
            "correct_answer": "All of the above"
          },
          {
            "question_2": "What is the critical component of taking ownership of a situation and handling it with confidence?",
            "answer_2": [
              "Putting the guest first",
              "Doing what you think",
              "Saying, “I’m sorry”",
              "Saying, “Not my problem”"

      ],
            "correct_answer": "Putting the guest first"
          }
        ]);
        break;

      default:
        return { "message": "error" }
    }
  }

  nextQuiz = () => {
    this.setState({
      index: this.state.index + 1,
      retry: false,
      showSurvey: true,
      showCorrect: false,
      showThanks: false,
      showError: false
    })
  }

  answerQuestion = val => {
    if (val === 0) {
      this.setState({ retry: true })
    } else {
      if (this.state.index === this.state.data.length - 1) {
        this.submitResult()
      } else {
        this.showCorrect()
      }
    }
  }

  submitResult = () => {

    this.showThanks()

    const {module, user} = this.props

    user.quizData[module] = Date.now();

    const apigClient = apigClientFactory.newClient({
      invokeUrl: aws.apiGateway.URL,
      region: aws.apiGateway.REGION,
      retryCondition: (err) => {
        return err.response.status === 500
      }
    })

    let headers = {'Access-Control-Allow-Origin': '*'}
    let pathTemplate = '/icare/quizzes'
    let method = 'POST'
    let params = {
      queryParams: {
        module: module,
        email: user.email
      }
    }

    apigClient.invokeApi(headers, pathTemplate, method, params)
      .then(result => {
      })
      .catch(error => {
        console.log('err: ', error)
      })
  }

  renderLoading = () =>{
    return (
      <div className="survey-loading">
        <img
          className="survey-loading-spinner"
          src="//s3-us-west-1.amazonaws.com/bss-guardian/assets/lax/loading.svg"
          alt=""
        />
      </div>
    )
  }

  renderSurvey = (retry) => {
    const quiz = this.state.data[this.state.index]

    return (
      <div>
        <span className="quiz-header">Quiz</span>
        <p className="question">
          {quiz['question_' + (this.state.index + 1)]}
        </p>
        <div className="multiple-choice">
          {quiz['answer_' + (this.state.index + 1)].map((ans, i) => (
            <div className="multiple-choice-item" key={i}>
              <input className="multiple-choice-radio" name="multiple-choice-radio" type="radio" value={ans} />
              {ans}
            </div>
          ))}
        </div>
        {this.state.retry && <p className="quiz-retry">Try again</p>}
        <button
          className="multiple-choice-review-video"
          onClick={this.props.onBack}>
          {'< Back'}
        </button>
        <button
          className="multiple-choice-submit"
          onClick={(event) => {
            event.preventDefault();
            const selector = 'input[name = "multiple-choice-radio"]:checked'
            const choice = document.querySelector(selector)
            this.answerQuestion(choice.value === quiz['correct_answer'] ? 1 : 0)
          }}>
          {'Submit >'}
        </button>
        <p className="quiz-text-below">
          Submit your answer to move forward, or click "Back" to review the video you were watching.
        </p>
        <p className="quiz-text-below">
          <span className="bold">Warning:</span> Clicking on your web browser's back button will return you to the previous page in your browser
        </p>
      </div>
    )
  }

  renderMessage = (msg, action) =>{
    setTimeout(action, 2100)

    return (
      <p style={{ color: 'green' }}>{msg}</p>
    )
  }

  renderError() {
    setTimeout(() => { this.props.onComplete()}, 2500)

    return (
      <p style={{ color: 'red' }}>
        An error occurred loading the survey. The next video will autoplay.
      </p>
    )
  }

  render() {
    return (
      <div className="survey">
        { this.state.loading && this.renderLoading() }
        { this.state.showSurvey && this.renderSurvey() }
        { this.state.showCorrect && this.renderMessage('Correct!', () => this.nextQuiz()) }
        { this.state.showThanks && this.renderMessage('Correct!', () => this.props.onComplete()) }
        { this.state.showError && this.renderError() }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Survey.js